export const PRINTFUL_CONNECTION_URL = 'https://www.printful.com/integration-callback/wix/silent-connect';
export const WIX_LOGIN_URL = 'https://users.wix.com/signin/signup/password';
export const TARGET_STEP_PARAM = 'stepTargetId';
export const WIX_META_SITE_ID_HEADER = 'x-wix-msid';
export const SESSION_STORAGE_APP_STATE_KEY = 'merch-maker-app-state';
export const TEMPLATE_META_SITE_ID = 'f9bf8eee-6569-46fa-b4e8-e6b8ca8990c1';
export const PREMIUM_URL = 'https://premium.wix.com/wix/api/premiumStart';
export const WIX_MANAGE_URL = 'https://manage.wix.com';
export const WIX_EDITOR_URL = 'https://manage.wix.com/editor';
export const WIX_DASHBOARD_URL = 'https://manage.wix.com/dashboard';
